// Session-feedback API — carved verbatim from `src/api/scribeAPIV2.ts` with
// the D6 family; transport from the `@heidi/api` configured-client registry.

import { getScribeHttpClients } from '@heidi/api/client';
import {
  type FeedbackV2Request,
  type GetUserFeedbackListResponse,
  type RecordNoteSuggestionFeedbackRequest,
  type RecordNoteSuggestionFeedbackResponse,
  type SubmitFeedbackResponse,
} from '../../contracts';

export const getFeedbackV2 = (sessionId: string) => {
  return getScribeHttpClients().scribeHttpV2.get<GetUserFeedbackListResponse>(
    `/sessions/${sessionId}/feedback`
  );
};

/**
 * Fire-and-forget note-suggestion feedback write.
 *
 * DOMAIN RULING (ARCFE-983): was `@domain REVIEW` in the hub; its sole caller
 * is the feedback family's `useMutateRecordNoteSuggestionFeedback`, so it is
 * ruled `@domain session` at carve (the dictation/commerce precedent). The
 * hub re-exports it name-intact.
 * @domain session
 */
export const recordNoteSuggestionFeedback = (input: {
  suggestionId: string;
  request: RecordNoteSuggestionFeedbackRequest;
}) => {
  return getScribeHttpClients().scribeHttpV2.post<RecordNoteSuggestionFeedbackResponse>(
    `/note-suggestions/${encodeURIComponent(input.suggestionId)}/feedback`,
    input.request
  );
};

/**
 * `POST /sessions/:id/feedback` — the session-level CSAT submit. Carved at
 * ARCFE-1001; the hub keeps a name-intact re-export.
 *
 * This is the ONE endpoint of the five the feedback family claimed that is
 * unambiguously session's by resource. The other four are
 * `entity-verification/*` routes and are recorded as an owned exclusion —
 * see the family's blockers.
 * @domain session
 */
export const submitFeedbackV2 = (
  sessionId: string,
  feedbackRequest: FeedbackV2Request
) => {
  return getScribeHttpClients().scribeHttpV2.post<SubmitFeedbackResponse>(
    `/sessions/${sessionId}/feedback`,
    feedbackRequest
  );
};
